export const blockIconsMapsLayersNew = (
	<span className='material-symbols-outlined'>layers</span>
);
